/**
 * Update strategies for worksheets.
 * @see net/disy/cadenza/workbook/service/query/QueryExecutionStrategyType.java
 */
export const QUERY_EXECUTION_STRATEGY_TYPE = ['auto', 'onDemand', 'periodical'] as const;
export type QueryExecutionStrategyType = (typeof QUERY_EXECUTION_STRATEGY_TYPE)[number];
